export default "__VITE_ASSET__tlOvs_S2__"